<template>
  <label class="elder-input__label" v-html="content"></label>
</template>

<script>
export default {
  props: ['value'],
  computed: {
    content() {
      if (this.value && typeof this.value === 'string') return this.value
      if (this.value && this.value.content) return this.value.content
      return this.$attrs.label
    },
  },
}
</script>
